module.exports = __webpack_public_path__ + "static/img/D200-X4.addcdf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/devices/D200-X4.png
// module id = spG+
// module chunks = 0